import { render } from "./CheckBoxInput.vue?vue&type=template&id=71d7601a&scoped=true&ts=true"
import script from "./CheckBoxInput.vue?vue&type=script&lang=ts"
export * from "./CheckBoxInput.vue?vue&type=script&lang=ts"

import "./CheckBoxInput.vue?vue&type=style&index=0&id=71d7601a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d7601a"]])

export default __exports__